export enum SelectFunctionType {
  ClickAndCollect,
  ScanAndGo,
  Loyalty,
}
